import { Directive, HostListener, Input } from '@angular/core';
import { DialogLinkService } from './dialog-link.service';

@Directive({
    selector: '[dialogLink]',
})
export class DialogLinkDirective {
    @Input() dialogLink: (string | number | any)[];

    constructor(private dialogLinkService: DialogLinkService) {}

    @HostListener('click', ['$event'])
    clicked(ev: Event) {
        if (this.dialogLink) {
            this.dialogLinkService.open(this.dialogLink, ev);
        }
    }
}
